import React from "react";
// import { connect } from 'react-redux';

const Loader = ({ isLoading = false }) => {
  return isLoading ? (
    <div className="loaderContainer">
      <p className="loader"></p>
    </div>
  ) : null;
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Common/Loader.jsx